module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-04@2x.93b48c77.jpg";